<template>
  <div class="metrics-trend-sparkline">
    <svg
      v-if="hasData"
      :viewBox="`0 0 ${W} ${H}`"
      preserveAspectRatio="none"
      class="metrics-trend-sparkline__svg"
    >
      <path :d="paths.areaPath" class="metrics-trend-sparkline__area" />
      <path :d="paths.linePath" class="metrics-trend-sparkline__line" />
    </svg>
    <div v-else class="metrics-trend-sparkline__empty" />
  </div>
</template>

<script>
import {
  buildSparklinePoints,
  buildSparklinePaths,
} from "@/utils/sparkline.js";

const W = 120;
const H = 32;
const PADDING = 3;

export default {
  name: "MetricsTrendSparkline",

  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return { W, H };
  },

  computed: {
    hasData() {
      return this.data && this.data.length >= 2;
    },

    paths() {
      const points = buildSparklinePoints(this.data, {
        width: W,
        height: H,
        padding: PADDING,
        domainMin: 0,
        domainMax: 100,
      });
      return buildSparklinePaths(points, H - PADDING);
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-trend-sparkline {
  height: 27px;
  flex-shrink: 0;

  &__svg {
    display: block;
    width: 100%;
    height: 100%;
    overflow: visible;
  }

  &__line {
    fill: none;
    stroke: #8a3ffc;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  &__area {
    fill: rgba(138, 63, 252, 0.1);
    stroke: none;
  }

  &__empty {
    width: 100%;
    height: 100%;
    background: var(--color-surface-primary-light, #ede9ff);
    border-radius: 6px;
  }
}
</style>
